// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    CiscoIntegrationNewLeafFillStatusResponse,
    CiscoIntegrationNewLeafRefillOrderValidationResponse,
    CiscoIntegrationTextingInternalEndpointsRequest,
    CiscoIntegrationTextingInternalEndpointsResponse,
    GatewayError,
    TcNewLeafRefillOrderValidationRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeCiscoApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param rxNumber 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async ciscoIntegrationNewLeafFillStatus (rxNumber: string, xProgramId?: string): Promise<AxiosResponse<CiscoIntegrationNewLeafFillStatusResponse>> {
        const _url_ = '/edge/cisco/integration/newLeafFillStatus/{rxNumber}'
            .replace('{' + 'rxNumber' + '}', encodeURIComponent(String(rxNumber)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'rxNumber' is not null or undefined
        if (rxNumber === null || rxNumber === undefined) {
            throw new Error('Required parameter rxNumber was null or undefined when calling ciscoIntegrationNewLeafFillStatus.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CiscoIntegrationNewLeafFillStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CiscoIntegrationNewLeafFillStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param tcNewLeafRefillOrderValidationRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async ciscoIntegrationNewLeafRefillOrderValidation (tcNewLeafRefillOrderValidationRequestModel: TcNewLeafRefillOrderValidationRequestModel, xProgramId?: string): Promise<AxiosResponse<CiscoIntegrationNewLeafRefillOrderValidationResponse>> {
        const _url_ = '/edge/cisco/integration/newLeafRefillOrderValidation';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tcNewLeafRefillOrderValidationRequestModel' is not null or undefined
        if (tcNewLeafRefillOrderValidationRequestModel === null || tcNewLeafRefillOrderValidationRequestModel === undefined) {
            throw new Error('Required parameter tcNewLeafRefillOrderValidationRequestModel was null or undefined when calling ciscoIntegrationNewLeafRefillOrderValidation.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tcNewLeafRefillOrderValidationRequestModel, "TcNewLeafRefillOrderValidationRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CiscoIntegrationNewLeafRefillOrderValidationResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CiscoIntegrationNewLeafRefillOrderValidationResponse");
        }
        return response;
    }
    /**
     * 
     * @param ciscoIntegrationTextingInternalEndpointsRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async ciscoIntegrationTextingInternal (ciscoIntegrationTextingInternalEndpointsRequest: CiscoIntegrationTextingInternalEndpointsRequest, xProgramId?: string): Promise<AxiosResponse<CiscoIntegrationTextingInternalEndpointsResponse>> {
        const _url_ = '/edge/cisco/integration/textingInternal';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'ciscoIntegrationTextingInternalEndpointsRequest' is not null or undefined
        if (ciscoIntegrationTextingInternalEndpointsRequest === null || ciscoIntegrationTextingInternalEndpointsRequest === undefined) {
            throw new Error('Required parameter ciscoIntegrationTextingInternalEndpointsRequest was null or undefined when calling ciscoIntegrationTextingInternal.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ciscoIntegrationTextingInternalEndpointsRequest, "CiscoIntegrationTextingInternalEndpointsRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CiscoIntegrationTextingInternalEndpointsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CiscoIntegrationTextingInternalEndpointsResponse");
        }
        return response;
    }
}
